module.exports = __webpack_public_path__ + "img/14_49.236d411c.png";